module.exports = __webpack_public_path__ + "img/web_icon_machine.71e88d64.png";